import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-29dcca6c")
const _hoisted_1 = { class: "card card-flush resource-guide" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold" }, "Resource guide")
], -1)
const _hoisted_3 = { class: "card-body px-9 py-4 pt-0 d-flex flex-column" }
const _hoisted_4 = { class: "w-100 my-4 d-flex" }
const _hoisted_5 = { class: "rounded m-2 svg-icon svg-icon-05x svg-icon-blue mt-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "m-0" }, " Video Library "),
  /*#__PURE__*/_createElementVNode("p", { class: "m-0 fw-bold" }, [
    /*#__PURE__*/_createTextVNode(" Helpful video tutorials to get you going can be found "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "m-0 hyperlink",
      href: "https://www.youtube.com/c/Multiorders/videos",
      target: "_blank"
    }, "here"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_7 = { class: "w-100 my-4 d-flex" }
const _hoisted_8 = { class: "rounded m-2 svg-icon svg-icon-05x svg-icon-blue mt-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "m-0" }, " Help Center "),
  /*#__PURE__*/_createElementVNode("p", { class: "m-0 fw-bold" }, [
    /*#__PURE__*/_createTextVNode(" Written guides on many popular questions are stored "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "m-0 hyperlink",
      href: "https://support.multiorders.com/",
      target: "_blank"
    }, "here"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_10 = { class: "w-100 my-4 d-flex" }
const _hoisted_11 = { class: "rounded m-2 svg-icon svg-icon-05x svg-icon-blue mt-0" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", { class: "m-0" }, " Support ", -1)
const _hoisted_14 = { class: "m-0 fw-bold" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Get in touch with our support team by sending us a message over the ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(".")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_inline_svg, {
            src: `${_ctx.originUrl}/assets/svg/icons/general/home.svg`
          }, null, 8, ["src"])
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_inline_svg, {
            src: `${_ctx.originUrl}/assets/svg/icons/general/group.svg`
          }, null, 8, ["src"])
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_inline_svg, {
            src: `${_ctx.originUrl}/assets/svg/icons/general/automation.svg`
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("p", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showIntercom())),
              class: "m-0 hyperlink"
            }, "live chat"),
            _hoisted_16
          ])
        ])
      ])
    ])
  ]))
}